import { metrics } from '@atlassian/browser-metrics';

export const globalIssueCreateModalLoad = metrics.interaction({
	key: 'global-issue-create-modal',
});

export const globalIssueCreateModalLoadSubsequent = metrics.interaction({
	key: 'global-issue-create-modal-subsequent',
});

export const successFlagDisplay = metrics.interaction({
	key: 'global-issue-create-dynamic-success-flag-display',
});

export const successFlagAddToSprintAction = metrics.interaction({
	key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action',
});

export const successFlagClearFiltersAction = metrics.interaction({
	key: 'global-issue-create-dynamic-success-flag-clear-filters-action',
});
